const styles = () => {
  return {
    inputRoot: {
      display: "flex",
    },
    input: {
      maxWidth: "50px",
    },
    inputContainer: {
      display: "flex",
    },
  };
};

export default styles;
